const parsers = [];

export function parse (context, forceInitialization = false) {
    parsers.forEach(parser => parser(context, true, forceInitialization));
}

export function registerParser (parser) {
    parsers.push(parser);
}

export function init () {
    parse(document.body);
}

// make parse function available for talention
window.parseComponent = function (context) {
    return parse(context);
};
